import { useAuth } from '../contexts/AuthContext';
import { useLanguage } from '../contexts/LanguageContext';
import { SignOut, Flask, House } from '@phosphor-icons/react';
import { Button } from './ui/button';

export default function PortalLayout({ children, clientName }) {
  const { user, logout } = useAuth();
  const { lang } = useLanguage();

  return (
    <div className="min-h-screen bg-[#F9F8F6]" data-testid="portal-layout">
      {/* Header */}
      <header className="bg-white border-b border-stone-200 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-14">
            <div className="flex items-center gap-4">
              <a href="/portal" className="flex items-center gap-2.5">
                <div className="w-8 h-8 bg-[#1f3e80] rounded flex items-center justify-center">
                  <span className="text-white font-bold text-sm font-heading">G</span>
                </div>
                <div>
                  <span className="text-sm font-heading font-semibold text-[#1f3e80] tracking-tight">GOYA INNOVA</span>
                  <span className="text-[10px] text-stone-400 ml-2">{lang === 'es' ? 'Portal de Cliente' : 'Client Portal'}</span>
                </div>
              </a>
            </div>
            <div className="flex items-center gap-4">
              {clientName && (
                <span className="text-sm font-medium text-stone-600">{clientName}</span>
              )}
              <div className="flex items-center gap-2 text-xs text-stone-500">
                <div className="w-7 h-7 rounded-full bg-[#1f3e80] text-white flex items-center justify-center text-[11px] font-semibold">
                  {(user?.name || '?')[0].toUpperCase()}
                </div>
                <span className="hidden sm:inline">{user?.name}</span>
              </div>
              <Button
                variant="ghost"
                size="sm"
                onClick={logout}
                className="text-stone-400 hover:text-red-600 gap-1.5 text-xs"
                data-testid="portal-logout-btn"
              >
                <SignOut size={14} />
                {lang === 'es' ? 'Salir' : 'Logout'}
              </Button>
            </div>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        {children}
      </main>

      {/* Footer */}
      <footer className="border-t border-stone-200 bg-white mt-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <p className="text-[11px] text-stone-400 text-center">
            Goya Innova — Evaluaciones Clinicas — eCRD &copy; {new Date().getFullYear()}
          </p>
        </div>
      </footer>
    </div>
  );
}
